module.exports = __webpack_public_path__ + "static/media/application.ab2020eb.png";